import { motion } from 'framer-motion';
import styled from 'styled-components';
import { white, primary } from 'constants/color';

export const ActionButton = styled(motion.button)`
  height: 25px;
  border: none;
  cursor: pointer;
  box-shadow: none;
  background: none;
  svg {
    width: 25px;
    height: 25px;
    fill: ${primary};
  }
`;

export const StyledTabWrapper = styled.div`
  max-width: 100% !important;
  margin-right: 10px;
  margin-bottom: 1rem;
`;

export const StyledWrapper = styled.div`
  padding: 1rem;
  overflow: auto;
  margin-right: 10px;
  margin-bottom: 1rem;
  background-color: ${white};
  ${({ theme }) => theme.scrollbar};
  border-radius: ${({ theme }) => theme.borderRadius};
  /* Mobile Devices */
  @media (max-width: 480px) {
    padding-bottom: 10px;
    width: 100% !important;
  }
`;
